/* PH · Produktseite: Mengen-Auswahl, Preis im Warenkorb-Button, PfirsichPoints */
(() => {
  const fmt = (cents, format) => {
    const f = format || '€{{amount_with_comma_separator}}';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const grp = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return grp(String(Math.round(cents / 100)), '.');
      if (k === 'amount_with_comma_separator') return grp(i, '.') + ',' + d;
      if (k === 'amount_no_decimals_with_comma_separator') return grp(String(Math.round(cents / 100)), '.');
      return grp(i, ',') + '.' + d;
    });
  };

  const scopeOf = (el) => el.closest('product-info') || document;

  const refresh = (scope) => {
    const qtyEl = scope.querySelector('input.quantity__input[name="quantity"]');
    const qty = Math.max(1, parseInt(qtyEl?.value, 10) || 1);
    const vol = scope.querySelector('ph-volume');
    const min = vol ? parseInt(vol.dataset.min, 10) : 0;
    const keep = vol ? parseInt(vol.dataset.keep, 10) : 100;
    vol?.querySelectorAll('[data-qty]').forEach((b) => {
      const on = parseInt(b.dataset.qty, 10) === 1 ? qty < min : qty >= min;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    const price = scope.querySelector('[data-ph-atc-price]');
    if (price) {
      const unit = parseInt(price.dataset.unit, 10) || 0;
      const each = vol && qty >= min ? Math.round((unit * keep) / 100) : unit;
      price.textContent = fmt(each * qty, price.dataset.moneyFormat);
    }
  };

  class PhVolume extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-qty]');
        if (!b) return;
        const input = scopeOf(this).querySelector('input.quantity__input[name="quantity"]');
        if (!input) return;
        input.value = b.dataset.qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      refresh(scopeOf(this));
    }
  }
  if (!customElements.get('ph-volume')) customElements.define('ph-volume', PhVolume);

  document.addEventListener('change', (e) => {
    if (e.target.matches?.('input.quantity__input[name="quantity"]')) refresh(scopeOf(e.target));
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest?.('quantity-input .quantity__button');
    if (b) requestAnimationFrame(() => refresh(scopeOf(b)));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const scope = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      if (!scope || !data.variant) return;
      const v = data.variant;
      const price = scope.querySelector('[data-ph-atc-price]');
      if (price) { price.dataset.unit = v.price; price.hidden = !v.available; }
      const one = scope.querySelector('[data-ph-vol-one]');
      const vol = scope.querySelector('ph-volume');
      if (one) one.textContent = fmt(v.price, price?.dataset.moneyFormat);
      const each = scope.querySelector('[data-ph-vol-each]');
      if (each && vol) each.textContent = fmt(Math.round((v.price * parseInt(vol.dataset.keep, 10)) / 100), price?.dataset.moneyFormat);
      const pts = scope.querySelector('[data-ph-points]');
      if (pts) pts.textContent = Math.floor(v.price / 100);
      const fresh = data.html?.getElementById(`PhStock-${data.sectionId}`);
      const stock = scope.querySelector(`#PhStock-${data.sectionId}`);
      if (fresh && stock) stock.innerHTML = fresh.innerHTML;
      refresh(scope);
    });
  }
})();
